import React, { useEffect, useState } from "react";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { TrustBar } from "@/components/landing/TrustBar";
import { Strategy } from "@/components/landing/Strategy";
import { Process } from "@/components/landing/Process";
import { About } from "@/components/landing/About";
import { WhyUs } from "@/components/landing/WhyUs";
import { BookSession } from "@/components/landing/BookSession";
import { Guide } from "@/components/landing/Guide";
import { Testimonials } from "@/components/landing/Testimonials";
import { SellProperty } from "@/components/landing/SellProperty";
import { FAQ } from "@/components/landing/FAQ";
import { Social } from "@/components/landing/Social";
import { Footer } from "@/components/landing/Footer";

function useScrollReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

export default function Landing() {
  useScrollReveal();
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[var(--ivory)] text-[var(--ink)]">
      <Nav scrolled={scrolled} />
      <Hero />
      <TrustBar />
      <Guide />
      <Strategy />
      <Process />
      <About />
      <WhyUs />
      <BookSession />
      <Testimonials />
      <SellProperty />
      <FAQ />
      <Social />
      <Footer />
    </div>
  );
}
